import segment from 'src/js/modules/analytics/segment';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';

const trackBlockLayoutDialogSubmitted = ({
  isOverlayClicked,
  blockId,
  blockVariationId,
  newBlockLayoutSelected,
}) => {
  if (!blockId) return;

  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.BLOCK_LAYOUT_DIALOG_SUBMITTED, {
    dialogId: dialogTypes.BLOCK_SETTINGS,
    triggerId: isOverlayClicked ? 'dialog-background' : 'submit-button',
    blockId,
    blockVariationId,
    newBlockLayoutSelected,
  });
};

export default trackBlockLayoutDialogSubmitted;
